export const _LOAD_MODEL_ = 'Load:Region';
export const _DELETE_REGION_ = 'Delete:Region';

export const MODEL = {
  city: '',
  state: null,
};
